import React, { Component } from "react";
import { connect } from "react-redux";
import { createHashHistory } from "history";
import PropTypes from "prop-types";
import {
  FormGroup,
  InputGroup,
  FormControl,
  Button,
  Alert
} from "react-bootstrap";
import Pagination from "react-paginating";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";
import { Notification } from "../../components/notifications";
import {
  getBannersList,
  deleteBanners
} from "../../redux/actions/bannersActions";
import isEmpty from "lodash.isempty";
import moment from "moment";
import "../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import loader from "../../style/loader/loader.scss";
import "../../style/banners/AddBanners.scss";
import ReactHtmlParser from "react-html-parser";

const history = createHashHistory();
class BannersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      banners: [],
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "",
      path: ["Home", "Banners"],
      links: ["home","banners"],
      search: "",
      limit: 25,
      show: false,
      isLoading: false,
      titleIcon: "fa fa-sort-down",
      descriptionIcon: "fa fa-sort-down",
      direction: "",
      orderBy: ""
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = e.target.value.length > 0 ? e.target.value : "";
    const postData = {
      page: 1,
      limit: 25,
      search: searchstring
    };
    if (searchstring.length > 0) {
      this.props.getBannersList(postData);
    }else{
      this.props.getBannersList({ page: this.state.page, limit: this.state.limit });
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}Icon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "fa fa-sort-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getBannersList({
      orderBy: orderBy,
      direction: direction,
      limit: this.state.limit
    });
  };

  componentWillMount() {
    if (this.props.bannersResponse && this.props.bannersResponse.message) {
      this.setState({
        alertMessage: this.props.bannersResponse.message,
        msgType: "success",
        show: true
      });
    }
    if (this.props.bannersUpdate && this.props.bannersUpdate.message) {
      this.setState({
        alertMessage: this.props.bannersUpdate.message,
        msgType: "success",
        show: true
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.fetchingBanners !== nextProps.fetchingBanners) {
      this.setState({ isLoading: nextProps.fetchingBanners });
    }
    if (
      this.props.bannersList !== nextProps.bannersList &&
      !isEmpty(nextProps.bannersList)
    ) {
      const setPageCount =
      nextProps.bannersList.total / nextProps.bannersList.per_page;
      this.setState({ banners: nextProps.bannersData });
      this.setState({ totalRecords: nextProps.bannersList.total });
      this.setState({ perPage: nextProps.bannersList.per_page });
      this.setState({ pageCount: setPageCount });
    }
    if (
      this.props.deletedBanners !== nextProps.deletedBanners &&
      !isEmpty(nextProps.deletedBanners)
    ) {
      if (nextProps.deletedBanners.message) {
        this.setState({
          alertMessage: nextProps.deletedBanners.message,
          msgType: "success",
          show: true
        });
        this.props.getBannersList({
          page: this.state.currentPage,
          limit: this.state.limit
        });
      }
    }
    if (this.props.error !== nextProps.error) {
      this.setState({
        alertMessage: nextProps.error,
        msgType: "warning",
        show: true
      });
    }
  }

  componentDidMount() {
    this.handlePageChange(1);
  }
  componentWillUnmount() {
    this.setState({ alertMessage: "", msgType: "", show: false });
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.getBannersList({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit
      });
    } else if (this.state.searchString !== "") {
      this.props.getBannersList({
        page: page,
        search: this.state.search,
        limit: this.state.limit
      });
    } else {
      this.props.getBannersList({ page: page, limit: this.state.limit });
    }
  };

  confirmDelete = bannersID => {
    this.props.deleteBanners(bannersID);
  };

  handleDelete(bannersID) {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(bannersID);
          this.handleShow();
        })
      ]
    });
  }

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    const Header = [
      "Title",
      "Start Date",
      "End Date",
      "Status",
      "Edit",
      "Delete"
    ];
    let bannersRow;
    let bannersdata = this.state.banners ? this.state.banners : [];
    if (bannersdata) {
      bannersRow = bannersdata.map((banners, index) => (
        <tr key={banners.bannersID}>
          <td>{banners.title}</td>
          <td><img className ="bannerImg" src={banners.banner_image} /></td>
          <td>{(banners.start_date) ? moment(banners.start_date).format("DD-MM-YYYY") : ""}</td>
          <td>{(banners.end_date) ? moment(banners.end_date).format("DD-MM-YYYY") : ""}</td>
          <td>{banners.status}</td>
          <td>
            <Button
              bsStyle="info"
              onClick={() => history.push(`/EditBanners/${banners.bannersID}`)}
            >
              {" "}
              Edit{" "}
            </Button>
            &nbsp;
            <Button
              bsStyle="danger"
              onClick={this.handleDelete.bind(this, banners.bannersID)}
            >
              {" "}
              Delete{" "}
            </Button>
          </td>
        </tr>
      ));
    }

    return (
      <div className="col-lg-12 banners-list">
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Manage Banners</header>
          <div className="panel-body">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            {this.state.isLoading ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="col-lg-12 text-right">
              <Button
                bsStyle="success"
                onClick={() => history.push("/AddBanners")}
              >
                + Add Banners
              </Button>
            </div>
            <div className="clearfix" />
            <div className="row m-t-15">
              <div className="col-lg-4 pull-right">
                <FormGroup>
                  <InputGroup>
                    <FormControl
                      type="text"
                      name="search"
                      onChange={this.handleSearch}
                    />
                    <InputGroup.Addon>
                      <i className="fa fa-search" />
                    </InputGroup.Addon>
                  </InputGroup>
                </FormGroup>
              </div>
            </div>
            <div className="col-lg-12">
              <table className="table table-hover" responsive="true">
                <thead>
                  <tr>
                    <th onClick={this.handleSort("title")}>
                      Title{" "}
                      <span
                        className={this.state.titleIcon}
                        aria-hidden="true"
                      />
                    </th>
                    <th> Banner Image</th>
                    <th> Start Date </th>
                    <th> End Date </th>
                    <th> Status </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>{bannersRow}</tbody>
              </table>

              <div className="text-center">
                <Pagination
                  total={totalRecords}
                  limit={perPage}
                  pageCount={pageCount}
                  currentPage={currentPage}
                >
                  {({
                    pages,
                    currentPage,
                    hasNextPage,
                    hasPreviousPage,
                    previousPage,
                    nextPage,
                    totalPages,
                    getPageItemProps
                  }) => (
                    <div className="pagination">
                      <button
                        {...getPageItemProps({
                          pageValue: 1,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        first
                      </button>

                      {hasPreviousPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: previousPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {"<"}
                        </button>
                      )}

                      {pages.map(page => {
                        let activePage = null;
                        if (currentPage === page) {
                          activePage = {
                            backgroundColor: "#ccc",
                            color: "#666"
                          };
                        }
                        return (
                          <button
                            key={page}
                            style={activePage}
                            {...getPageItemProps({
                              pageValue: page,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {hasNextPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: nextPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {">"}
                        </button>
                      )}

                      <button
                        {...getPageItemProps({
                          pageValue: totalPages,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        last
                      </button>
                    </div>
                  )}
                </Pagination>
              </div>
            </div>
            <div className="clearfix" />
          </div>
        </div>
      </div>
    );
  }
}

BannersList.propTypes = {
  getBannersList: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  bannersList: state.bannersReducers.bannersList,
  bannersData: state.bannersReducers.bannersData,
  error: state.bannersReducers.error,
  deletedBanners: state.bannersReducers.deletedBanners,
  bannersResponse: state.bannersReducers.bannersResponse,
  bannersUpdate: state.bannersReducers.bannersUpdate,
  fetchingBanners: state.bannersReducers.fetchingBanners
});

export default connect(mapStateToProps, { getBannersList, deleteBanners })(
  BannersList
);



// WEBPACK FOOTER //
// ./src/app/views/banners/BannersList.js